export const parseTrendApiResponse = (data) => {
  if (!data?.status || !Array.isArray(data.data)) return null;
  if (!data.data.every((row) => row && typeof row.period === "string" && typeof row.value === "number")) {
    return null;
  }
  return data.data;
};

export const getDefaultChartDates = () => {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - 30);
  return { start, end };
};

export const toApiDates = (dates) => {
  if (!dates?.start || !dates?.end) {
    return { startDate: null, endDate: null };
  }
  const start = new Date(dates.start);
  start.setHours(0, 0, 0, 0);
  const end = new Date(dates.end);
  end.setHours(23, 59, 59, 999);
  return {
    startDate: start.toISOString(),
    endDate: end.toISOString(),
  };
};

export const toAxiosDates = (dates) => {
  if (!dates?.start || !dates?.end) {
    return { start: null, end: null };
  }
  const start = new Date(dates.start);
  start.setHours(0, 0, 0, 0);
  const end = new Date(dates.end);
  end.setHours(23, 59, 59, 999);
  return {
    start: start.toISOString(),
    end: end.toISOString(),
  };
};

export const buildFilterPayload = (selectedTags = []) => ({
  site: selectedTags.filter((e) => e.key === "site").map((e) => e.value),
  obrBu: selectedTags.filter((e) => e.key === "obrBu").map((e) => e.value),
  obrOrg: selectedTags.filter((e) => e.key === "obrOrg").map((e) => e.value),
  mainSites: selectedTags.filter((e) => e.key === "inspectionType").map((e) => e.value),
});

export const limitTopSiteResponses = (list, limit = 12) =>
  [...(list || [])]
    .sort((a, b) => b.positive + b.negative - (a.positive + a.negative))
    .slice(0, limit);

export const trimSiteLabel = (name, max = 14) => {
  if (!name) return "N/A";
  const formatted = name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  return formatted.length > max ? `${formatted.slice(0, max)}…` : formatted;
};

export const aggregateTopSitesByFindings = (data, topN = 10) => {
  const bySite = {};
  (data || []).forEach((row) => {
    const name = row.siteName || "Unknown";
    bySite[name] = (bySite[name] || 0) + (row.findingCount || 0);
  });
  return Object.entries(bySite)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count)
    .slice(0, topN);
};

export const formatDateChip = (start, end) => {
  if (!start || !end) return "All time";
  const fmt = (d) => d.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  return `${fmt(start)} – ${fmt(end)}`;
};

export const toDateInputValue = (date) => {
  if (!date) return "";
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const fromDateInputValue = (value) => {
  if (!value) return null;
  const parsed = new Date(`${value}T12:00:00`);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};
